export default function Pagination({ page, setPage, maxPage, nextDisabled }) {
  const onChange = (e) => {
    const value = e.target.value;
    if (parseInt(value) <= 0 || parseInt(value) > maxPage || value === "") {
      return;
    }
    setPage(parseInt(value));
  };

  const onFocus = (e) => e.target.select();

  return (
    <div className="w-full flex items-center justify-center gap-2 py-4">
      <button
        className="bg-slate-700 hover:bg-slate-600 disabled:opacity-30 disabled:cursor-not-allowed text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors"
        disabled={page === 1}
        onClick={() => setPage(page - 1)}
      >
        ← Prev
      </button>
      <input
        className="w-16 text-center bg-slate-800 border border-slate-600 text-white text-sm rounded-lg py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        onChange={onChange}
        type="number"
        value={page}
        onFocus={onFocus}
      />
      <button
        className="bg-slate-700 hover:bg-slate-600 disabled:opacity-30 disabled:cursor-not-allowed text-white text-sm font-medium px-5 py-2 rounded-lg transition-colors"
        disabled={nextDisabled}
        onClick={() => setPage(page + 1)}
      >
        Next →
      </button>
      <span className="text-slate-400 text-sm ml-2">
        of <span className="text-white font-semibold">{maxPage}</span>
      </span>
    </div>
  );
}
